import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  ViewChild,
  Output,
  EventEmitter,
} from '@angular/core';
import { Font, FontService } from '../font.service';
import { BehaviorSubject, Observable, Subscription, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { CanvasService } from '../../../../../services/canvas/canvas.service';
import { Store } from '@ngrx/store';
import { setDescriptorValue } from '../../../../store/editor.crud.actions';
import { bulkUpdateFinish } from '../../../../store/editor.actions';
import { selectIsStudioMode } from '../../../../store/studio/studio.selector';
import { textStyleChange } from '../../../../store/studio/studio.actions';

@Component({
  selector: 'nw-font-family-selector',
  templateUrl: './font-family-selector.component.html',
  styleUrls: ['./font-family-selector.component.scss'],
})
export class FontFamilySelectorComponent implements OnDestroy {
  @ViewChild('search') searchElement: ElementRef;
  @ViewChild('selector') selectorElement: ElementRef;

  @Input() emitOnly = false;
  @Output() fontSelected = new EventEmitter<string>();

  fonts$: Observable<Font[]>;
  showSelector = false;
  private searchText$ = new BehaviorSubject<string>('');
  clickSub: Subscription;
  searchText = 'Search';
  selectedFont: string;
  currentFontFamily: string;
  isStudioMode$: Observable<boolean>;
  isStudioMode = false;
  studioModeSub: Subscription;

  @Input()
  set fontFamily(val: string) {
    this.currentFontFamily = val;
  }

  get fontFamilyToDisplay() {
    return this.currentFontFamily;
  }

  defaultFonts: Font[] = [
    'Arial',
    'Verdana',
    'Tahoma',
    'Times New Roman',
    'Georgia',
    'Courier New',
    'Trebuchet MS',
    'Comic Sans MS',
    'sans-serif',
    'serif',
    'monospace',
  ].map(name => ({ name, category: 'default' }));

  constructor(
    private readonly service: FontService,
    private readonly cs: CanvasService,
    private readonly store: Store,
    private readonly fontService: FontService,
  ) {
    this.fonts$ = combineLatest([this.service.fonts$, this.searchText$]).pipe(
      map(([fonts, searchText]) => [
        this.defaultFonts.concat(fonts),
        searchText,
      ]),
      map(([fonts, searchText]: [Font[], string]) => {
        if (!searchText) {
          return fonts;
        }
        return fonts.filter(font =>
          font.name.split(' ').find(word => word.startsWith(searchText)),
        );
      }),
    );

    this.isStudioMode$ = this.store.select(selectIsStudioMode);
    this.studioModeSub = this.isStudioMode$.subscribe(
      isStudioMode => (this.isStudioMode = isStudioMode),
    );
  }

  get searchTextBaseFormat() {
    return this.searchText.charAt(0).toUpperCase() + this.searchText.slice(1);
  }

  updateFontFamily(value: string) {
    if (this.isStudioMode) {
      // In studio mode, dispatch textStyleChange action
      this.store.dispatch(
        textStyleChange({
          style: { fontFamily: value },
        }),
      );
    } else {
      // In regular mode, dispatch setDescriptorValue action
      this.store.dispatch(
        setDescriptorValue({
          key: 'textConfig',
          innerKey: 'fontFamily',
          value,
        }),
      );
    }
  }

  finishUpdate() {
    this.store.dispatch(bulkUpdateFinish());
  }

  ngOnDestroy(): void {
    this.studioModeSub?.unsubscribe();
  }
  ngAfterViewInit() {
    this.clickSub = this.cs.clickEvent.subscribe(() => {
      this.showSelector = false;
    });

    const rect = this.selectorElement.nativeElement.getBoundingClientRect();
  }

  close() {
    // -- // -- //
  }

  abovePositionMode = false;

  toggleSelector() {
    const rect = this.selectorElement.nativeElement.getBoundingClientRect();
    console.log('bottom', rect.bottom, 'top', rect.top); // screen

    if (rect.bottom > window.innerHeight - 500) {
      this.abovePositionMode = true;
    } else {
      this.abovePositionMode = false;
    }

    if (this.showSelector) {
      this.showSelector = false;
      return;
    }
    this.showSelector = true;
    this.searchText = 'Search';
    setTimeout(() => {
      this.focusInput();
    });
  }

  focusInput() {
    this.searchElement.nativeElement.focus();
    this.searchElement.nativeElement.setSelectionRange(
      0,
      100,
      // this.searchText.length,
    );
  }
  openList() {
    console.log('open-list');
  }

  searchTextChange(event: Event) {
    event.stopPropagation();
    const value = (event.target as HTMLInputElement).value;

    const searchText = value.charAt(0).toUpperCase() + value.slice(1);
    this.searchText$.next(searchText);
  }

  @HostListener('wheel', ['$event'])
  onWheel(event: WheelEvent) {
    event.stopPropagation();
  }

  selectFont(font: Font) {
    if (this.emitOnly) {
      this.fontSelected.emit(font.name);
      this.showSelector = false;
      return;
    }
    this.updateFontFamily(font.name);
    this.fontService._loadFont(font.name).then(() => {
      this.finishUpdate();
    });
    this.showSelector = false;
  }
}
